module.exports = __webpack_public_path__ + "static/media/2017.c5344b8a.jpg";